export function getType(s){
  if(typeof s=="number"){
      s=s.toString()
  }
   let codes=JSON.parse(sessionStorage.getItem("codes"))
   let codesvalues=JSON.parse(sessionStorage.getItem("codesvalues"))
   let arr=s.split(",")
   let types=[]
   let ss
   for(let i in arr){
    for(let j in codes){
      
        if(arr[i]==codes[j]){
            
            ss=codesvalues[j]
            types.push(ss) 
        }
    }
   
   
    
}
    return types.join(",")
}
export function backType(s){
   let codesvalues=JSON.parse(sessionStorage.getItem("codesvalues"))
   let codes=JSON.parse(sessionStorage.getItem("codes"))
   
    let arr=s.split(",")
    let types=[]
    let ss
    for(let i in arr){
        for(let j in codes){
            if(arr[i]==codesvalues[j]){
                ss=codes[j]
            }
        }
        types.push(ss) 
    }
    return types.join(",")
}



// WEBPACK FOOTER //
// ./src/utils/typeAuth.js